function showModalProductAdmission({currentPrices, picture, name, id}) {
    modals.openModal(null, '#product-admission', modal => {
        const wrapper = modal.querySelector('.js-product-admission');

        let price = '';
        const productAdmissionId = modal.querySelector('.js-form-product-admission-id');
        const productAdmissionName = modal.querySelector('.js-form-product-admission-name');
        const productAdmissionPrice = modal.querySelector('.js-form-product-admission-price');

        if (productAdmissionId && id) {
            productAdmissionId.value = id;
        }

        if (productAdmissionName && name) {
            productAdmissionName.value = name;
        }

        if (productAdmissionPrice && currentPrices && currentPrices.PRICE) {
            productAdmissionPrice.value = currentPrices.PRICE;
        }

        if (currentPrices) {
            if (+currentPrices.PERCENT > 0) {
                price = `
                <div class="adds-to-cart__price _sale">
                    <div class="product-card__price-info-old">
                        <span class="product-card__price-info-old-value">
                            ${currentPrices.BASE_PRICE}
                            <span class="rub">
                                <i>руб.</i>
                            </span>
                        </span>
                        <span class="product-card__price-info-old-sale">–${currentPrices.PERCENT}%</span>
                    </div>
                    <div class="product-card__price-info-current">
                        <strong class="product-card__price-info-current-value product-card__price-info-current-value--sale">
                            ${currentPrices.PRICE}
                            <span class="rub">
                                <i>руб.</i>
                            </span>
                        </strong>
                    </div>
                </div>
            `
            } else {
                price = `
                <div class="adds-to-cart__price">
                    <div class="product-card__price-info-current">
                        <strong class="product-card__price-info-current-value">
                            ${currentPrices.PRICE}
                            <span class="rub">
                                <i>руб.</i>
                            </span>
                        </strong>
                    </div>
                </div>
            `
            }
        }

        wrapper.innerHTML = `
            <div class="adds-to-cart__info">
                ${picture ? `
                    <div class="adds-to-cart__image">
                        <img src="${picture}" alt="${name}" width="162" height="162">
                    </div>
                ` : ''}
                <div class="adds-to-cart__content">
                    ${name ? `
                        <p class="adds-to-cart__title">${name}</p>
                    ` : ''}
                    ${price}
                </div>
            </div>
        `
    })
}
